import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import UiDialog from 'ui-components/ui-dialog/UiDialog';

export const StyledSendToBulletin = styled('div')(
  () => css`
    .send-to-bulletin {
      cursor: pointer;
      color: #777 !important;
      white-space: nowrap;

      .icon {
        margin-left: 8px;
      }
    }
  `
);

export const StyledSendToBulletinDialog = styled(UiDialog)(
  () => css`
    &.send-to-bulletin-dialog {
      .send-to-bulletin-title {
        padding: 12px 20px !important;

        .title-content {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;
          min-width: 0;
        }

        .title-back-link {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: auto;
          padding: 12px 8px !important;
          padding: 0;
          line-height: 0;
        }

        .title-text {
          font-size: 0.875rem;
          font-weight: 700;
          line-height: 1.5rem;
          color: #0c395a;
        }
      }

      .send-to-bulletin-body {
        padding: 16px 20px !important;
      }

      .send-to-bulletin-actions {
        justify-content: flex-end;

        button {
          min-width: 100px;
          margin: 0;
        }
      }
    }

    @media (max-width: 900px) {
      &.send-to-bulletin-dialog {
        .MuiPaper-root {
          width: calc(100% - 32px);
          margin: 16px;
        }
      }
    }
  `
);
